export const successNotification = {
  title: 'Estás de volta 😉!',
  message: 'É bom estar contigo novamente!',
  type: 'info',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 7000
  }
}
export const errorNotification = {
  title: 'Não reconhecemos o email e/ou password que colocaste',
  message: 'Verifica novamente',
  type: 'danger',
  insert: 'top',
  container: window.innerWidth > 768 ? 'top-right' : 'bottom-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 3000
  }
}
